function RadioToggleElement() {
  $('input[type=radio][data-toggle-element]').on('change', function(event) {
    $('input[type=radio][data-toggle-element]').each(function(i, radio) {
      if (radio.dataset.toggleElement != event.target.dataset.toggleElement) {
        $('#' + radio.dataset.toggleElement).show();
      } else {
        $('#'+ radio.dataset.toggleElement).hide();
      }
    });
  });
}

exports.init = RadioToggleElement;
